import React from 'react';
import { Edit, useNotify, useRedirect } from 'react-admin';
import { NEWS_POSTS_RESOURCE, textNotification } from '../common';
import NewsPostForm, { notifySaveError, stickyPreviewSx } from '../form/NewsPostForm';

// Sin la barra de acciones de react-admin («Mostrar»): como en la ficha, se vuelve con «← Volver al
// listado», y así las dos vistas empiezan a la misma altura.
// Pesimista: el back traduce al guardar y hay que esperar su respuesta para pintar las
// traducciones y el estado nuevos, no el registro optimista.
const NewsPostEdit = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(...textNotification('Cambios guardados.', { type: 'success' }));
        redirect('show', NEWS_POSTS_RESOURCE, data.id);
    };

    return (
        <Edit title="Editar publicación" actions={false} mutationMode="pessimistic" mutationOptions={{ onSuccess, onError: notifySaveError(notify) }} sx={stickyPreviewSx}>
            <NewsPostForm />
        </Edit>
    );
};

export default NewsPostEdit;
